<template>
  <div style="display:flex;justify-content:center;">
    <div class="box">
      <dig-form @OnSubmit="OnSubmit" title="Login" :fullwidthButton=true :items="items" :isLoading="isLoggingIn"></dig-form>
    </div>
  </div>
</template>

<script>
import Form from '../digilib_web/vue/form.vue'

export default {
  props: {
    isLoggingIn: Boolean
  },
  components: {
		'dig-form' : Form
  },
  methods: {
    OnSubmit: function(val) {
      this.$emit('OnLogIn', val);
    }
  },
  data() {
		return {
			items: [
        {name:'username', title:'username', icon:'fa fa-user', inputType:'input', required: true},
        {name:'password', title:'password', icon:'fa fa-at', type:'password', inputType:'input', required: true},
      ]
		}
	}
}
</script>

<style scoped>
.box {
  box-shadow: 0 2px 15px 0 rgba(16, 37, 133, 0.5);
  border-radius: 4px 4px 4px 4px;
  font-size: 0.9em;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  width: 300px;
  margin-top: 100px;
  background-color: rgba(255, 255, 255, 0.7);
}
@media all and (max-width: 640px) {
  .box {
    width: 90vw;
  }
}
</style>
